import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {environment} from 'src/environments/environment';
import { EstimativaNegociacao, EstimativaNegociacaoLista } from '../interface/estimativa-negociacao';
import { UtilService } from './util';
import { IFiltroListaEstimativaNegociacao } from '../filter/filtro-lista-estimativa-negociacao';

@Injectable({
  providedIn: 'root'
})
export class EstimativaNegociacaoService {
  url = `${environment.urlApiProtheus}/wsrestnegociacao`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
  ) {
  }

  getEstimativaNegociacao(CZACCDNGC: string): Observable<EstimativaNegociacao> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<EstimativaNegociacao>(`${this.url}/${CZACCDNGC}`,httpOptions);
  }

  getEstimativaNegociacaoLista(filtro: IFiltroListaEstimativaNegociacao): Observable<EstimativaNegociacaoLista> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<EstimativaNegociacaoLista>(`${this.url}`,httpOptions);
  }

  postEstimativaNegociacao(dados: EstimativaNegociacao): Observable<EstimativaNegociacao> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post<EstimativaNegociacao>(`${this.url}`,dados,httpOptions);
  }
  deleteEstimativaNegociacao(CZACCDNGC: string): Observable<any> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.delete(`${this.url}/${CZACCDNGC}`,httpOptions);
  }


}
